const SUBSCRIPTION_CREATED = 'Subscription Created';
const SUBSCRIPTION_UPDATED = 'Subscription Updated';
const SUBSCRIPTION_CANCELLED = 'Subscription Cancelled';
const SUBSCRIPTION_CANCELLATION_SCHEDULED =
  'Subscription Cancellation Scheduled';
const SUBSCRIPTION_PAUSED = 'Subscription Paused';
const SUBSCRIPTION_STOPPED = 'Subscription Stopped';
const SUBSCRIPTION_RESUMED = 'Subscription Resumed';
const SUBSCRIPTION_PAYMENT_SUCCEEDED = 'Subscription Payment Succeeded';
const SUBSCRIPTION_PAYMENT_SUCCEEDED_USING_COUPON =
  'Subscription Payment Succeeded Using Coupon';
const SUBSCRIPTION_PAYMENT_FAILED = 'Subscription Payment Failed';
const SUBSCRIPTION_PAYMENT_REFUNDED = 'Subscription Payment Refunded';
const SUBSCRIPTION_PLAN_UPGRADED = 'Subscription Plan Upgraded';
const SUBSCRIPTION_UPGRADE_CHECKED = 'Subscription Upgrade Checked';
const CHANGE_PLAN_CLICKED = 'Change Plan Clicked';
const REACTIVATE_PLAN_CLICKED = 'Reactivate Plan Clicked';
const RESUME_PLAN_CLICKED = 'Resume Plan Clicked';
const UPDATE_PAYMENT_INFO_CLICKED = 'Update Payment Info Clicked';
const CANCEL_PLAN_CLICKED = 'Cancel Plan Clicked';

export const BILLING_ANALYTICS_EVENTS = {
  SUBSCRIPTION_CREATED,
  SUBSCRIPTION_UPDATED,
  SUBSCRIPTION_CANCELLED,
  SUBSCRIPTION_CANCELLATION_SCHEDULED,
  SUBSCRIPTION_PAUSED,
  SUBSCRIPTION_STOPPED,
  SUBSCRIPTION_RESUMED,
  SUBSCRIPTION_PAYMENT_SUCCEEDED,
  SUBSCRIPTION_PAYMENT_SUCCEEDED_USING_COUPON,
  SUBSCRIPTION_PAYMENT_FAILED,
  SUBSCRIPTION_PAYMENT_REFUNDED,
  SUBSCRIPTION_PLAN_UPGRADED,
  SUBSCRIPTION_UPGRADE_CHECKED,
  CHANGE_PLAN_CLICKED,
  REACTIVATE_PLAN_CLICKED,
  RESUME_PLAN_CLICKED,
  UPDATE_PAYMENT_INFO_CLICKED,
  CANCEL_PLAN_CLICKED,
};
